import { translate } from '../../../../utils/translation'
import { formatNumber } from '../../../../utils/numbers'
import Title from '../../checkoutModal/common/Title'
import ReachedText from '../../checkoutModal/common/ReachedText'
import Icon from '../../../icon/Icon'
import warning from '../../../../styles/assets/warning-icon.svg'
import ReachedTextContainer from '../../checkoutModal/common/ReachedTextContainer'

const ModalTitle = ({
  interactionType,
  searchType,
  text,
  quantity,
  isAddProjectFlow,
  maxLimitMessage,
}) => {
  const getTranslateKey = () => {
    const type = interactionType === 'signup' ? 'sign_up' : 'log_in'

    return `${type}_heading_${searchType}`
  }

  const changeEscapeToBreak = (value) => value.replace(/\n/g, '<br />')

  const formatTextToEllipsis = (value) => {
    const MAXIMUM_TEXT_SIZE = 24

    return value.length < MAXIMUM_TEXT_SIZE
      ? value
      : `${value.substring(0, MAXIMUM_TEXT_SIZE)}...`
  }

  if (isAddProjectFlow) {
    return (
      <>
        {text && (
          <ReachedTextContainer>
            <Icon size="20px" src={warning} />
            <ReachedText>
              {translate(text, maxLimitMessage.reachedText)}
            </ReachedText>
          </ReachedTextContainer>
        )}
        <Title
          dangerouslySetInnerHTML={{
            __html: translate(searchType, maxLimitMessage.title),
          }}
          style={{
            b: {
              whiteSpace: 'pre-line',
            },
          }}
        />
      </>
    )
  }

  return (
    <Title
      dangerouslySetInnerHTML={{
        __html: changeEscapeToBreak(
          translate(
            getTranslateKey(),
            formatNumber(quantity),
            formatTextToEllipsis(text),
          ),
        ),
      }}
      style={{
        b: {
          whiteSpace: 'pre-line',
        },
      }}
    />
  )
}

export default ModalTitle
